import * as React from 'react';

const ReceiptsSection: React.FC = () => {
  return <>Omlouváme se, tuto sekci připravujeme.</>;
};

export default ReceiptsSection;
